// ----------------------------------------------------------------------------
// Template: Product
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import {load} from '@shopify/theme-sections';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/reviews/reviews';
import 'snippets/cart-confirmation/cart-confirmation';
import 'snippets/_containers/swatches/swatches';
import 'snippets/specs-table/specs-table';
import 'snippets/_containers/form/form-increment';
import 'snippets/variant-picker/variant-picker';
import 'snippets/size-guide/size-guide';
import 'snippets/model-product-grid/model-product-grid';

import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/product/product';

import 'sections/product-recommendations/product-recommendations';
import 'sections/pickup-availability/pickup-availability';

// Styles
import './_product.scss';


// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('DOMContentLoaded', () => {
    load('*');
});
